import React, { useEffect } from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

// Data array for features
const features = [
    {
        title: 'FAST',
        description: 'Launch in months, not years',
        details: [
            'It can take years to create a custom blockchain environment.',
            'Launch your own environment in mere months with GetChkd.',
        ],
        imageSrc: 'https://cdn.prod.website-files.com/62255cd8edf9b346239ca36f/622585bb5d11285e2fc74672_Blockchain.png',
    },
    {
        title: 'EASY',
        description: 'One integration unlocks all',
        details: [
            'Enable global interoperability via GetChkd’s API: connect hardware to software, on-chain to off-chain, legacy to current and future systems, online to offline & more.',
        ],
        imageSrc: 'https://cdn.prod.website-files.com/62255cd8edf9b346239ca36f/622585bcd2520021c9361f77_API.png',
    },
    {
        title: 'SECURE',
        description: 'Control access to sensitive data',
        details: [
            'Customize role and rule-based access for Zero Trust to physical locations, data, and devices - paired with detailed audit trails.',
            'Infinite sources of truth can act as one, yet remain siloed and never revealing any underlying data.',
        ],
        imageSrc: 'https://cdn.prod.website-files.com/62255cd8edf9b346239ca36f/622585bb90c714cbab6adb54_Protected.png',
    },
];

const Aboutus = () => {
    // Scroll event to update the background position
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.pageYOffset;
            const parallaxElements = document.querySelectorAll('.parallax');
            parallaxElements.forEach((element) => {
                element.style.backgroundPosition = `center ${-(scrollPosition * 0.2)}px`; // Adjust the 0.2 factor for speed
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            {/* Main title section */}
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12}>
                    <Typography
                        variant="h1"
                        align="center"
                        sx={{
                            marginBottom: '50px',
                            marginTop: '50px',

                            fontSize: '3rem', // Increase font size
                            fontWeight: 'bold', // Make the text bolder
                            letterSpacing: '2px', // Add some spacing between letters for emphasis
                            lineHeight: '1.2', // Improve line height for better readability
                            textTransform: 'uppercase', // Capitalize the text
                            textShadow: '2px 2px 8px rgba(0, 0, 0, 0.3)', // Add a subtle shadow for extra depth
                        }}
                        paragraph
                        color="primary"
                    >
                        About Us
                    </Typography>
                </Grid>
            </Grid>

            {/* Parallax Feature Section */}
            <section
                id="feature-section"
                className="solution-section features parallax"
                style={{
                    backgroundImage: 'url(https://uploads-ssl.webflow.com/62255cd8edf9b346239ca36f/6225836a86425a87f4381813_ConnectedWorld1.jpg)',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    paddingTop: '120px',
                    paddingBottom: '120px',
                    position: 'relative',
                    zIndex: '1',
                    transition: 'background-position 0.3s',
                }}
            >
                {/* Main Heading inside the Parallax */}
                <Grid container spacing={4} justifyContent="center">
                    <Grid item xs={12} sm={10} md={6}>
                        <Typography variant="h1" align="center" color="text.primaryLight">
                            <Typography variant="h1" component="span" color="text.primaryLight">
                                We make using blockchain for interoperability
                            </Typography>
                            <Typography variant="h1" component="span" color="text.light">
                                <strong color="text.secondary"> fast &amp; easy</strong>
                            </Typography>, while keeping data
                            <Typography variant="h1" component="span" color="text.light">
                                <strong> secure</strong>
                            </Typography>
                        </Typography>
                    </Grid>
                </Grid>

                {/* Feature Grid: Dynamic display of features */}
                <Grid container spacing={6} justifyContent="center" alignItems="flex-start" style={{ marginTop: '20px' }}>
                    {features.map((feature, index) => (
                        <Grid item xs={12} sm={2} display="flex" flexDirection="column" alignItems="center" key={index}>
                            {/* Feature Image */}
                            <img
                                src={feature.imageSrc}
                                height={80}
                                width={80}
                                alt={feature.title}
                                style={{ marginBottom: '20px' }}
                            />

                            {/* Feature Title */}
                            <Typography variant="h2" component="div" color="text.primaryLight" align="center" style={{ marginBottom: '20px' }}>
                                <strong>{feature.title}</strong>
                            </Typography>

                            {/* Feature Description */}
                            <Typography variant="h3" color="text.light" align="center" style={{ marginBottom: '20px', fontWeight: 'bolder', marginLeft: '5px', marginRight: '5px', fontFamily: 'Verdana, Geneva, sans-serif' }}>
                                <strong>{feature.description}</strong>
                            </Typography>

                            {/* Feature Details */}
                            {feature.details.map((detail, idx) => (
                                <Typography
                                    key={idx}
                                    variant="h4"
                                    color="text.primaryLight"
                                    align="center"
                                    style={{ marginBottom: '20px', fontFamily: 'Verdana, Geneva, sans-serif' }}
                                >
                                    {detail}
                                </Typography>
                            ))}
                        </Grid>
                    ))}
                </Grid>
            </section>
            <Box sx={{ backgroundColor: 'white', padding: 4 }}>
                {/* The GetChkd Platform Heading */}
                <Container maxWidth="lg">
                    <Typography variant="h1" align="center" color="primary"
                        sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                        The GetChkd platform
                    </Typography>
                    {/* Image - GIF */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img
                            src="https://cdn.prod.website-files.com/62255cd8edf9b346239ca36f/63f8ccf2b4293a49ca7e3634_getchkd%20key%20visual%20looping.gif"
                            alt="Animated GIF highlighting how GetChkd connects companies to blockchain"
                            width="922"
                            loading="lazy"
                        />
                    </Box>
                </Container>



            </Box>
        </>
    );
};

export default Aboutus;
